export function normalizeComparison(item = {}) {
  return {
    date_label: item.date_label || "-",
    has_stat_period: Boolean(item.has_stat_period),
    new_count: Number(item.new_count || 0),
    consumed_count: Number(item.consumed_count || 0),
    cancelled_count: Number(item.cancelled_count || 0),
    failed_count: Number(item.failed_count || 0),
    net_change: Number(item.net_change || 0),
  };
}

export function buildTrendDatasets(items = []) {
  const metric = (field) => items.map((item) => (
    item && item.has_stat_period ? Number(item[field] || 0) : null
  ));

  return {
    labels: items.map((item) => item.date_label || "-"),
    newCount: metric("new_count"),
    consumedCount: metric("consumed_count"),
    cancelledCount: metric("cancelled_count"),
    failedCount: metric("failed_count"),
    netChange: metric("net_change"),
  };
}
